/* src/app/invoice/register/invoice-register-presenter/invoice-register-presenter.component.scss */
body#themeTag :host ::ng-deep .total-row {
  font-weight: bold;
}
body#themeTag :host ::ng-deep .p-datatable .p-datatable-scrollable-wrapper .p-datatable-scrollable-view .p-datatable-scrollable-header {
  height: 3em;
}
body#themeTag :host ::ng-deep .p-datatable .p-datatable-wrapper {
  height: 70vh;
}
/*# sourceMappingURL=invoice-register-presenter.component.css.map */
